import { ReactElement } from 'react';
import { ErrorPageProps } from 'shared/domain/error-page';
import ErrorPageStyled from './ErrorPage.styled';

const { ErrorPageWrapper, ErrorCard, IconCircle, Title, Description, ActionButton } = ErrorPageStyled;

const ErrorPage = ({
  primaryText = 'Regresar',
  primaryAction,
  title = 'Error interno del servidor',
  message = 'Ha ocurrido un inconveniente en nuestro servidor. Por favor, comuníquese con soporte técnico del sistema.',
}: ErrorPageProps): ReactElement => {
  return (
    <ErrorPageWrapper>
      <ErrorCard>
        <IconCircle>
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </IconCircle>
        <Title>{title}</Title>
        <Description>{message}</Description>
        <ActionButton type="button" onClick={primaryAction}>
          {primaryText}
        </ActionButton>
      </ErrorCard>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
